import React from 'react';
import * as styles from './NotificationCommentPreview.module.scss';
import { gql } from '../graphql/generated/gql';
import type { DocumentType } from '../graphql/generated/gql';
import CommentPreview from '../post/comment/CommentPreview';
import CommentContext from '../utils/post/CommentContext';

const NOTIFICATION_FRAGMENT = gql(`
  fragment NotificationCommentPreview_notification on Notification {
    id
    ... on CommentNotification {
      comment {
        id
        content
        thread {
          id
          context
        }
      }
    }
  }
`);

interface NotificationCommentPreviewProps {
  hideContext?: boolean;
  notification: DocumentType<typeof NOTIFICATION_FRAGMENT>;
}

const NotificationCommentPreview = ({
  hideContext,
  notification,
}: NotificationCommentPreviewProps) => {
  if (!('comment' in notification) || !notification.comment) {
    return null;
  }

  return (
    <div className={styles.container}>
      {!hideContext && (
        <div className={styles.context}>
          <CommentContext context={notification.comment.thread.context} />
        </div>
      )}
      <div className={styles.preview}>
        <CommentPreview
          content={notification.comment.content}
          maxLines={8}
          link={false}
        />
      </div>
    </div>
  );
};

export default NotificationCommentPreview;
